module.exports = __webpack_public_path__ + "images/buttons/login_big.png";